<template>
<div>
  <v-radio-group
    :row="true"
    v-model="val"
    @change="changeValue"
    class="lmr_category"
  >
    <v-radio label="Infos locales" value="general"/>
    <v-radio label="Sports" value="sport"/>
    <v-radio v-if="this.$parent.consumer_group=='ebra'"label="Magazine" value="magazine"/>
    <v-radio v-if="this.$store.state.consumerName=='lng'"label="Faits Divers" value="faits_divers"/>
    <v-radio :label="$t('all')" value=""/>
  </v-radio-group>
</div>
</template>

<script>
export default {
  props: {
    value: String,
  },
  data () {
    return {
      val: ''
    }
  },
  methods: {
    changeValue () {
      this.$emit('input', this.val)
      this.$emit('change', this.val)
    }
  }
}
</script>
<style lang="sass">
.lmr_category
  label
    margin-bottom: 0
</style>



// WEBPACK FOOTER //
// LmrCategoryFilter.vue?12d62664